import { useIntl } from 'react-intl';
import { useState, FC, useEffect } from 'react';
import { useMount } from 'ahooks';
import { Typography } from 'iglooform';
import classnames from 'classnames';
import useMobile from '@/hooks/useMobile';
import { history, IRouteComponentProps, useLocation, useDispatch } from 'umi';
import { getSession } from '@/utils/common';
import Steps from '@/components/steps';
import { BackButton } from '@/components/back-button/back-button';
import useUpdateRemoteLangMessage from '@/hooks/useUpdateRemoteLangMessage';
import useQuoteSteps from './hooks/useQuoteSteps';
import * as SESSION_KEYS from '@/configs/session-storage-keys';
import './index.less';

const CreateQuote: FC<IRouteComponentProps> = ({ match }) => {
  const isMobile = useMobile();
  const { params }: any = match;
  const { query, state }: any = useLocation();

  const { currentActiveStep, totalStep, button } = query;
  const planPicked = getSession(SESSION_KEYS.PICKED_PLAN_INFO);

  const dispatch = useDispatch();

  const productType = params.type;

  const { formatMessage } = useIntl();

  const [activeStep, setActiveStep] = useState(() => {
    return currentActiveStep || productType;
  });

  const isBuyNowFlow = button === 'buyNow';

  const canNotEnterPage = state?.from !== 'product-list' && !isBuyNowFlow;

  const getPlanCmsDetail = () =>
    dispatch({
      type: 'quote/getPlanCmsDetail',
      payload: {
        productType: params.type,
        productId: planPicked?.productKey,
        planId: planPicked?.planKey,
      },
    });

  useMount(() => {
    window.history.replaceState({}, document.title);
    planPicked && getPlanCmsDetail();
  });

  useUpdateRemoteLangMessage([() => planPicked && getPlanCmsDetail()]);

  useEffect(() => {
    if (canNotEnterPage) {
      history.replace(`/home/${productType}/product-list`);
      return;
    }

    sessionStorage.removeItem(SESSION_KEYS.STILL_NEED_CACHE);

    return () => {
      const stillNeedCache = sessionStorage.getItem(
        SESSION_KEYS.STILL_NEED_CACHE,
      );

      if (!stillNeedCache && !isBuyNowFlow) {
        sessionStorage.removeItem(SESSION_KEYS.QUOTE_INFO);
        sessionStorage.removeItem(SESSION_KEYS.FIRST_STEP_INFO_FAST_QUOTE);
        sessionStorage.removeItem(SESSION_KEYS.PICKED_PLAN_INFO);
      }
    };
  }, []);
  const vehicleSteps = useQuoteSteps(
    isBuyNowFlow ? '1' : totalStep,
    productType,
    setActiveStep,
    isBuyNowFlow,
  );

  if (canNotEnterPage) return null;

  return (
    <div className={classnames(['QuoteContainer', { 'is-mobile': isMobile }])}>
      <BackButton handleClick={() => history.goBack()} />

      <div className="Title">
        <Typography level="h2">
          {formatMessage(
            isBuyNowFlow ? { id: 'Application' } : { id: 'FastQuote' },
          )}
        </Typography>
        <div className={'subTitle'}>
          <Typography level="body1">
            {formatMessage({
              id: 'All fields are required unless marked optional.',
            })}
          </Typography>
        </div>
      </div>

      <div className="Steps">
        <Steps
          steps={vehicleSteps}
          setActiveStep={setActiveStep}
          activeStep={activeStep}
        ></Steps>
      </div>
    </div>
  );
};

export default CreateQuote;
